import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from 'ic-snacks'

import { trackEvent } from 'utils/events/trackEvent'

import { type ChartsData } from 'legacy/components/DataViz/dataViz.types'
import { chartsToCsv, generateCsvUri } from 'legacy/components/DataViz/Charts/chartUtils'

interface Props {
  chartData: { [key: string]: ChartsData }
  chartTitle?: string
}

const DownloadChartCta: React.FC<Props> = ({ chartData, chartTitle }) => {
  if (!chartTitle) return null

  const handleDownload = generateCsvUri(chartsToCsv(chartData))
  const handleAnalytics = () =>
    trackEvent({
      id: 'charts.csv_downloaded',
      description: 'Downloaded a charted dataset',
      data: { chart: chartTitle },
    })

  return (
    <div data-testid="download-chart-cta">
      <Button
        href={handleDownload}
        onClick={handleAnalytics}
        elementAttributes={{ download: `${chartTitle}-${new Date().toLocaleString()}.csv` }}
        size="small"
        style={{ textDecoration: 'none' }}
      >
        <FormattedMessage id="charts.download" />
      </Button>
    </div>
  )
}

export default DownloadChartCta
